import axios from "../axios-auth";
import orginal_axios from "axios";


export const customerCreditBalanceService = {
  getCustomerCreditBalance,
  getCustomerCreditBalanceSummary,
  exportCreditBalanceExcel,
  printCustomerCreditBalance
};

function getCustomerCreditBalance(searchParams, page, size) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }

  let params = {
    page: page,
    size: size
  };

  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.saleType) {
    params["saleType"] = searchParams.saleType;
  }
  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  return axios.get("/auth/customer-credit-balance", { params });
}

function printCustomerCreditBalance(searchParams, page, size) {
  if (!page) {
      page = 0;
  } else {
      page -= 1;
  }

  let params = {
      page: page,
      size: size
  };

  if (searchParams.status) {
      params["status"] = searchParams.status;
  }
  if (searchParams.saleType) {
      params["saleType"] = searchParams.saleType;
  }
  if (searchParams.customerCode) {
      params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.customerName) {
      params["customerName"] = searchParams.customerName;
  }
  if (searchParams.fromDate) {
      params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
      params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shopId) {
      params["shopId"] = searchParams.shopId;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  return axios.get("/auth/print-customer-credit-balance", { params });
}

function getCustomerCreditBalanceSummary(searchParams) {
  let params = {};

  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.saleType) {
    params["saleType"] = searchParams.saleType;
  }
  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  return axios.get("/auth/customer-credit-balance-summary", { params });
}
function exportCreditBalanceExcel(searchParams) {
  let params = {
  };
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.saleType) {
    params["saleType"] = searchParams.saleType;
  }
  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  return orginal_axios({
      method: "GET",
      url: axios.defaults.baseURL + "/auth/customer-credit-balance-excel",
      params,
      responseType: "arraybuffer", // important
      headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
  }).then(function (response) {
      return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

